import { render, staticRenderFns } from "./StackRanking.vue?vue&type=template&id=428d228a&scoped=true&"
import script from "./StackRanking.vue?vue&type=script&lang=js&"
export * from "./StackRanking.vue?vue&type=script&lang=js&"
import style0 from "./StackRanking.vue?vue&type=style&index=0&id=428d228a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d228a",
  null
  
)

export default component.exports